<template>
  <div id="contenedor-configuracion-firma-desktop">
    <v-data-table
      :headers="headers"
      :items="listado">
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'ConfiguracionFirmasDesktop',
  props: {
    listado: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        {
          text: 'Orden',
          align: 'start',
          sortable: false,
          value: 'orden',
          width: '1%',
        },
        { text: 'Funcionario', sortable: false, value: 'funcionario.nombre' },
        { text: '', sortable: false, value: 'acciones' },
      ],
    };
  },
};
</script>

<style lang="scss">

</style>
